<template>
  <vk-modal :has-close-icon="false" @close="closeModal" class="ov-hidden">
    <template slot="header">
      <fire-toast/>
      <div class="d-flex jc-between text-bold p-2 p-1:mo">
        <div class="text-bold as-center">{{ occupation }}</div>
        <div class="d-flex">
          <button
              @click="closeModal"
              :disabled="showSpinner"
              class="btn-secondary btn-small text-bold m-r-2:t">
            Close
          </button>
          <button
              @click="savePrices"
              :disabled="showSpinner"
              class="btn btn-small text-bold">
            Save
          </button>
        </div>
      </div>
    </template>
    <template   slot="content">
      <div v-if="showSpinner" class="BODY d-flex ai-center">
        <spinner class="m-x-auto m-y-6" size="100px"/>
      </div>
      <transition name="VERTICAL" mode="out-in">
        <div class="BODY">
          <div class="BODY-HEADER layout p-2 p-1:mo">
            <div class="layout-item is-4 ">Service</div>
            <div class="layout-item is-5 ">Payment Type</div>
            <div class="layout-item is-3 ">Pricing</div>
          </div>
          <pricing-service-item
              v-for="service in localServices"
              :service="service"
              :key="service.id"
              class="layout"
              @input="handleInput"/>
        </div>
      </transition>
    </template>
    <template slot="footer">
      <div class="bg-white w-100 d-flex fd-row">
        <vk-icon
            name="information-filled"
            size="24"
            class="p-r-1 flex-0-0"
            unbounded/>
        <span class="TEXTDISCLAIMER">
          Prices should estimate the cost of your labor for the service.
          You do not need to include an estimate of the material cost in your pricing.
        </span>
      </div>
    </template>
  </vk-modal>
</template>

<script>
import axios from '@homeservices/api-kit/axios';
import { mapGetters } from 'vuex';
import {
  getOccupationsServices,
} from '@homeservices/api-kit/serviceprovider/occupations';
import PricingServiceItem from './PricingServiceItem';

export default {
  name: 'pricing-modal',
  components: {
    PricingServiceItem,
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
    occupation: {
      type: String,
      required: true,
    },
    occupationId: {
      type: [Number, String],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      updatedServices: [],
      occupationServiceIds: null,
      isLoading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    localServices () {
      return this.services;
    },
    showSpinner () {
      return this.loading || this.isLoading;
    },
  },
  async mounted () {
    await this.fetchOccupationServiceIds();
  },
  methods: {
    async savePrices () {
      this.isLoading = true;
      const params = {};

      // Filter the updated services to include only those that have changes in their properties
      params.services = this.updatedServices.filter((updatedService) => {
        const originalService = this.localServices
          .find(service => service.id === updatedService.id);
        return originalService.unit !== updatedService.unit
               || originalService.minimum_price !== updatedService.minimum_price
               || originalService.maximum_price !== updatedService.maximum_price;
      });
      // Map the updated services to the format required by the API. Enpoin requires service_provider_occupation_service_id over service_id
      params.services = params.services.map((service) => {
        const occupationServiceId = this.occupationServiceIds[service.id];
        return {
          service_provider_occupation_service_id: occupationServiceId,
          unit: service.unit,
          minimum_price: service.minimum_price,
          maximum_price: service.maximum_price,
        };
      });

      try {
        await axios.post(`/platform/serviceprovider/r/service-provider-occupation-services-price/${this.serviceProviderId}/v1`,
          params
        );
      } catch (e) {
        this.$fireToast({
          message: 'We cannot update pricing at this time. Please try again later.',
        });
        console.error(e); // eslint-disable-line no-console
      }
      // setting a timeout to avoid race conditions public-profile api call
      setTimeout(() => {
        this.isLoading = false;
      }, 1500);
    },
    handleInput (service) {
      const index = this.updatedServices.findIndex(s => s.id === service.id);
      if (index === -1) {
        this.updatedServices.push(service);
      } else {
        this.updatedServices.splice(index, 1, service);
      }
    },
    async fetchOccupationServiceIds () {
      const { data } = await getOccupationsServices({
        service_provider_occupation_ids: this.occupationId,
      });

      const occupationServices = data.results.reduce((acc, result) => {
        acc[result.service_id] = result.id;
        return acc;
      }, {});

      this.occupationServiceIds = occupationServices;
    },
    closeModal () {
      this.updatedServices = [];
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  /deep/ .BODY {
    @include responsive('max-width', 100%, $tablet, $desktop, $wide);
    width: 940px;
    }
  .BODY {
    min-height: 90vh;
  }
  .BODY-HEADER {

    width: 100%;

    font-weight: 700;
    background-color:  #F4F4F4;
    border-bottom: solid 1px $color-gray50;
  }
  /deep/ .CONTENT {
    padding:0px;
    max-width: 100%;
    max-height: 100%;
    overflow-y:auto;
  }
  /deep/ .FOOTER {
    background-color: white;
    border-top: solid 1px $color-gray50;
  }
  /deep/ .HEADER {
    border-bottom: solid 1px $color-gray50;
  }
  /deep/ .FIRE-TOAST {
      color: $color-red;
      border: 1px solid $color-red;
      background-color: $color-gray30;
  }
  .TEXTDISCLAIMER {
      font-size: 14px;
      font-weight: 400;
    }
</style>
